import { render, staticRenderFns } from "./cert-list.vue?vue&type=template&id=e226c67e&scoped=true"
import script from "./cert-list.vue?vue&type=script&lang=js"
export * from "./cert-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e226c67e",
  null
  
)

export default component.exports